import React from 'react';
import { Tooltip, styled, tooltipClasses } from '@ublend-npm/aulaui-core';
import { DARK } from '@core/constants/theme';

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.mode === DARK ? '#D7D2DF' : '#5D536C',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.mode === DARK ? '#D7D2DF' : '#5D536C',
    color: theme.palette.mode === DARK ? '#230254' : '#FFFFFF',
  },
}));

export default StyledTooltip;
